import { useState } from "react";
import LinesEllipsis from "react-lines-ellipsis";

export const EllipsisText = ({
  className,
  text,
  maxLine = 3,
}: {
  className?: string;
  maxLine?: number;
  text: string;
}) => {
  const [useEllipsis, setUseEllipsis] = useState(true);

  if (useEllipsis) {
    return (
      <LinesEllipsis
        className={className}
        text={text}
        maxLine={maxLine}
        // @ts-ignore
        ellipsis={
          <button
            className="text-primary"
            onClick={() => setUseEllipsis(false)}
          >
            ...查看更多
          </button>
        }
        basedOn="letters"
      />
    );
  }

  return <div className={className}>{text}</div>;
};
